import React from "react";
import { Property } from "@/services/types/property";
import PropertyCard from "../PropertyCard/PropertyCard";
import LoadingSpinner from "@/components/common/LoadingSpinner/LoadingSpinner";

interface PropertyGridProps {
  properties: Property[];
  isLoading?: boolean;
  error?: string | null;
  emptyMessage?: string;
}

const PropertyGrid: React.FC<PropertyGridProps> = ({
  properties,
  isLoading = false,
  error = null,
  emptyMessage = "No properties found.",
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <LoadingSpinner size="lg" color="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 max-w-md mx-auto">
          <p className="font-medium">Error loading properties</p>
          <p className="text-sm mt-1">{error}</p>
        </div>
      </div>
    );
  }

  if (!properties || properties.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="bg-gray-50 border border-gray-200 text-gray-600 px-4 py-3 max-w-md mx-auto">
          <p className="font-medium">{emptyMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-5">
      {properties.map((property) => (
        <PropertyCard key={property._id} property={property} />
      ))}
    </div>
  );
};

export default PropertyGrid;

